import './styles.scss';
import React, {Dispatch, useEffect, useRef, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";

/* Types, Constants, Utils */
import * as Constants from "../../../constants";

/* Bootstrap */
import {Container, Nav, Navbar} from "react-bootstrap";

/* Components */
import MyLibraryDropdown from "../my-library-dropdown";
import Utils from "../../../utils";
import {AnyAction} from "@reduxjs/toolkit";
import {useDispatch, useSelector} from "react-redux";
import { setIndustry } from '../../../redux/slices/search-slice';
import {removeToCrumb} from "../../../redux/slices/breadcrumb-slice";
import {IBreadCrumbState} from "../../../types/redux/breadcrumb";
import {RootState} from "../../../redux";

const HeaderIDL = ():JSX.Element => {
  /* redux */
  const breadcrumbState: IBreadCrumbState = useSelector<RootState, IBreadCrumbState>(state => state.breadcrumb);

  /* refs */
  const navbarToggleRef:React.MutableRefObject<any> = useRef(null);

  /* state */
  const [toggleActive, setToggleActive] = useState<boolean>(false);
  const [active, setActive] = useState<string>(null)
  const [libraryMenuOpen, setLibraryMenuOpen] = useState<boolean>(false)
  const [expanded, setExpanded] = useState(false)

  /* hooks */
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch:Dispatch<AnyAction> = useDispatch();

  useEffect(()=>{
    const pathname: string = location.pathname;
    const segments: string[] = pathname.split('/');
    setActive(segments[segments.length-2]);
  }, [location.pathname, setActive]);

  useEffect(()=>{
    if (!libraryMenuOpen) {
      setExpanded(false)
    }
  }, [libraryMenuOpen])

  const handleToggle = ():void => {
    if (toggleActive) {
      navbarToggleRef.current.blur();
    }
    setToggleActive(!toggleActive);
  }

  const navLink = (label: string, link: string): JSX.Element => {
    const segments: string[] = link.split('/');
    const isActive: boolean = segments[segments.length-2] === active;
    return <Nav.Link
        onClick={()=>{
          dispatch(removeToCrumb(breadcrumbState.breadcrumbs[0]));
          dispatch(setIndustry(Constants.ALL_INDUSTRIES))
          setExpanded(false);
          setTimeout(()=>{
            navigate(link)
          })
        }}
        className={"link text-color-primary text-normal text-nowrap position-relative pb-0 mb-0"  + (isActive ? ' bold': '')} as={Link} to={'#'}
    >
      <div className={'d-inline-block' + (isActive ? ' ': ' mb-0')}>
        {label}
        <div className={'active_select' + (isActive ? ' ': ' hidden')}/>
      </div>
    </Nav.Link>
  }

  return (
    <div className={'header-idl bg-white pt-3'}>
      <Navbar className={"p-0"} expanded={expanded}  expand="lg" onToggle={handleToggle}>
        <Container className={'align-items-baseline'}>
          <div
            className={'d-inline-block text-large font-thin text-nowrap p-0 mb-4 '}
            role={'button'}
            onClick={()=> {
              navigate('/' + Constants.HOME + '/')
            }}
          >
            Industry Documents Library
          </div>

          <Navbar.Toggle aria-controls={"header-navbar-nav"} ref={navbarToggleRef} onClick={()=>setExpanded(!expanded)}/>
          <Navbar.Collapse id="header-navbar-nav" className={"justify-content-end " + (active ? '' : '')}>
            <Nav className={" "}>
              {navLink(Utils.toTitleCase(Constants.INDUSTRIES), '/' + Constants.HOME + '/')}
              {navLink(Utils.toTitleCase(Constants.NEWS), '/' + Constants.NEWS + '/')}
              {navLink(Utils.toTitleCase(Constants.RESOURCES), '/' + Constants.RESOURCES + '/')}
              {navLink(Utils.toTitleCase(Constants.ABOUT_IDL), '/' + Constants.ABOUT_IDL + '/')}
              {navLink(Utils.toTitleCase(Constants.HELP), '/' + Constants.HELP + '/')}
              <Nav.Item
                className={"link text-normal text-nowrap position-relative pb-0 mb-0"}
              >
                <div className={'library-dropdown d-inline-block position-relative'}>
                  <MyLibraryDropdown  opened={setLibraryMenuOpen}/>
                  <div className={'active_select mt-0 mt-lg-3 ' +
                      (active === Utils.convertToKeyOrId(Constants.MY_LIBRARY) ? ' library': ' library hidden') +
                      (libraryMenuOpen ? ' library-menu-open-select': '') }/>
                </div>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>

        </Container>
      </Navbar>
    </div>
  )
}

export default HeaderIDL;
